import { Env } from '@app/types/env';
import { NgxLoggerLevel } from 'ngx-logger';

export const environment: Env = {
    appVersion: `${require('../../package.json').version}`,
    production: true,
    apiBaseUrl: 'https://digital-factory-ebos-backend-main.aws-euw1-pro.bacardiapps.com/edms-rest',
    apiBaseUrlIdea: 'https://digital-factory-ideapp-backend-main.aws-euw1-pro.bacardiapps.com',
    apiManagmentKey: 'gtwkXCX1nGHKsALqRHeprEMG1kRaWV3D',
    logLevel: NgxLoggerLevel.ERROR,
    azureRoot: 'dev',
    clientId: '1ac140d9-1b38-4688-a2bb-453dcfa61fbf',
    authority: 'https://login.microsoftonline.com/9e16780e-719d-496b-a880-24ac20c30a60',
    clientSecretOauth: 'SS4E9kpGoBYuKt1M',
    endpointAccessToken: 'https://dev-apim.integration.bacardiapps.com/v1/oauthv2/cors/token',
    // eslint-disable-next-line no-bitwise
    powerApplink: 'https://app.powerbi.com/groups/0fba6035-3ba3-4f3b-ad49-2a6da9a672a9/reports/5a0b5836-b829-4fb1-ab3b-d$',
      // eslint-disable-next-line max-len
    ideaUid: 'aWRhdWlk',
    clientIdGraphs: 'acca9fb1-6f23-4a07-b3cb-2fcb4439ebe2',
    clientSecretGraphs: 'rV~8Q~V3sRBH3uYW_K55T61LP1xsRIAoQjT4sbzY',
    endpointGraphsAccessToken: 'https://login.microsoftonline.com/9e16780e-719d-496b-a880-24ac20c30a60/oauth2/token'
  };
